import React, { useState, useEffect } from "react";
import { Card, Table, Spinner, Modal, Image, Col, Row, Pagination, Container, Form, Button, ButtonGroup, InputGroup } from "@themesberg/react-bootstrap";
import { useParams } from "react-router-dom";
import TableRow from "../../components/StateOverview/TableRow";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faDownload, faSearch } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import { BASE_URL } from "../../constants";
import Layout from '../../components/Layout';
import { ProgressTrackWidget } from "../../components/Widgets";
const RefugeeDetails = () => {
  const { id } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;
  const [refugees, setRefugees] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [refugeeDetails, setRefugeeDetails] = useState(null); 
   const [error, setError] = useState(null);

  
  const [searchQuery, setSearchQuery] = useState(''); 

  useEffect(() => {
    const fetchRefugees = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/shelters/${id}`);
        const fetchedRefugees = response.data.rooms;
  
        setRefugees(fetchedRefugees);
        // Extract all occupants from all rooms
        const occupants = fetchedRefugees.flatMap((room) => room.occupant);
  
        // Fetch availability for each occupant
        const availabilityPromises = occupants.map((occupant) =>
          axios.get(`${BASE_URL}/refugees/${occupant._id}/availability`)
        );
  
        const availabilityResponses = await Promise.all(availabilityPromises);
        const availabilityData = availabilityResponses.map((res) => res.data);
  
        // Map availability data back to the occupants inside the rooms
        const refugeesWithAvailability = fetchedRefugees.map((room) => ({
          ...room,
          occupant: room.occupant.map((occupant, index) => ({
            ...occupant,
            availability: availabilityData[index] || {}  
          })),
        }));
  
        // Update state with the new data (rooms with availability information)
        setRefugees(refugeesWithAvailability);
      } catch (error) {
        console.error("Error fetching users or availability:", error);
      } finally {
        setLoading(false);
      }
    };
  
    fetchRefugees();
  }, [id]);

  // Filter refugees based on the search query
  const uniqueById = (arr) => {
    const seen = new Set();
    return arr.filter(item => {
      if (seen.has(item._id)) {
        return false;
      }
      seen.add(item._id);
      return true;
    });
  };
  
  const filteredRefugees = uniqueById(
    refugees.flatMap(room =>
      room.occupant.filter(occupant =>
        `${occupant.firstName} ${occupant.lastName}`.toLowerCase().includes(searchQuery.toLowerCase())
      )
    )
  );
  

  useEffect(() => {
    setCurrentPage(1); // Reset to first page when search changes
  }, [searchQuery]);

  const totalPages = Math.ceil(filteredRefugees.length / itemsPerPage);

  const paginatedRefugees = filteredRefugees.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );



  const handleExport = async (shelterId) => {
    setLoading(true);
    setError(null); 
    try {
      // Send GET request to export shelter data by ID
      const response = await axios.get(`${BASE_URL}/shelters/export/${shelterId}`, {
        responseType: 'blob', 
      });
      const blob = new Blob([response.data], { type: 'text/csv' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `shelter_${shelterId}_export.csv`; // Set the filename for the export
      link.click();
    } catch (error) {
      console.error("Error exporting shelter data:", error);
      setError("Failed to export shelter data. Please try again later.");
    } finally {
      setLoading(false); 
    }
  };
  const handlePhotoClick = (photoUrl) => {
    setSelectedPhoto(photoUrl);
    setShowModal(true); 
  };

  const handleNameClick = async (id) => {
    try {
      const response = await axios.get(`${BASE_URL}/refugees/${id}`);
      setRefugeeDetails(response.data); // Store refugee details
      setShowDetailModal(true); // Open modal with details
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <Spinner animation="border" variant="primary" />
      </div>
    );
  }

  return (
    <Layout>
    <Container className="py-4 px-0"> 
      <h4>Shelters Details</h4>
      <Row className="d-flex justify-content-between align-items-center py-3">
  {/* Search Input - Left */}
    <Col>
    <div className="btn-toolbar mb-2 mb-md-0">
      <InputGroup className="w-50">
        <InputGroup.Text>
          <FontAwesomeIcon icon={faSearch} />
        </InputGroup.Text>
        <Form.Control
          type="text"
          placeholder="Search by user name"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </InputGroup>
    </div>
  </Col>

  {/* Export Button - Right */}
  <Col xs={12} md="auto" className="mb-2">
    <ButtonGroup>
      <Button
        variant="outline-cyan"
        size="sm"
        onClick={() => handleExport(id)}
        disabled={loading}
      >
        <FontAwesomeIcon icon={faDownload} className="me-2" />
        {loading ? "Exporting..." : "Export"}
      </Button>
    </ButtonGroup>
  </Col>
</Row>

              {paginatedRefugees.length > 0 ? (       
      <Card border="light" className="table-wrapper table-responsive shadow-sm mt-3" style={{ maxHeight: "500px" }}>
        <Card.Body className="pt-0">
     
        <Table hover className="user-table align-items-center">
        <thead>
          <tr>
            <th>User</th>
            <th>Entry Date</th>
            <th>Availability</th>
          </tr>
        </thead>
        <tbody>
          {paginatedRefugees.map((occupant) => (
            <tr
              key={occupant._id || `${occupant._id}-${Math.random()}`}
              className="hover-effect"
            >
              <td>
                <div className="d-flex align-items-center">
                  {occupant.profilePhoto && (
                    <div className="position-relative me-2">
                      <img
                        src={occupant.profilePhoto}
                        alt="avatar"
                        className="rounded-circle"
                        style={{ width: "40px", height: "40px", cursor: "pointer" }}
                        onClick={() => handlePhotoClick(occupant.profilePhoto)}
                      />
                      {occupant.isConnected !== undefined && (
                        <span
                          className={`position-absolute bottom-0 end-0 rounded-circle border border-white ${
                            occupant.isConnected ? "bg-success" : "bg-danger"
                          }`}
                          style={{
                            width: "10px",
                            height: "10px",
                            boxShadow: "0 0 2px rgba(0,0,0,0.2)",
                          }}
                        ></span>
                      )}
                    </div>
                  )}
                  <div>
                    <span
                      className="fw-bold"
                      style={{ cursor: "pointer" }}
                      onClick={() => handleNameClick(occupant._id)}
                    >
                      {occupant.firstName && occupant.lastName
                        ? `${occupant.firstName} ${occupant.lastName}`
                        : "No Responsible Person"}
                    </span>
                  </div>
                </div>
              </td>
              <td>
                {occupant.entryDate
                  ? new Date(occupant.entryDate).toLocaleDateString()
                  : ""}
              </td>
              <td>
                <span
                  className={`badge ${
                    occupant.availability?.status === "Available"
                      ? "bg-success"
                      : "bg-danger"
                  }`}
                >
                  {occupant.availability?.status || "N/A"}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <Pagination className="justify-content-center mt-2">
          <Pagination.Prev
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((prev) => prev - 1)}
          />
          {[...Array(totalPages)].map((_, i) => (
            <Pagination.Item
              key={i + 1}
              active={i + 1 === currentPage}
              onClick={() => setCurrentPage(i + 1)}
            >
              {i + 1}
            </Pagination.Item>
          ))}
          <Pagination.Next
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((prev) => prev + 1)}
          />
        </Pagination>
      )}

                  </Card.Body>
                  </Card>
                
              ) : (
                <div className="card mt-3">
                <div className="card-body">
                  <p className="card-text">No Users found.</p>
                </div>
              </div>
              )}
        
    
      <Col xs={12}  className="mb-4">
                  <ProgressTrackWidget />
                </Col>
    </Container>
      </Layout>
 
  );
};

export default RefugeeDetails;